<template>
    <a href="/inbox" v-bind:class="['bg-dark list-group-item list-group-item-action', {'text-active': active  }]">
        <div class="d-flex w-100 justify-content-start align-items-center">
            <span class="fas fa-inbox fa-lg fa-fw"></span>
            <span class="inbox-badge badge badge-pill badge-primary mr-1">{{ inboxCount }}</span>
            <span class="menu-collapsed">Inbox</span>
        </div>
    </a>    
</template>

<script>
export default {
    props: {
    },   
    data() {
        return {
            inboxCount: 0,
            active: (window.location.pathname == '/inbox'),
        };
    },
    methods: {
        update: function() {
            axios.get('/ajax/inbox/count').then(response => (this.inboxCount = response.data));
        }
    },      
    created() {
        var self = this;
        window.Echo.private('inbox.' + window.Laravel.user)
            .listen('InboxEvent', (e) => {
                self.update();
                eventHub.$emit('inbox-refresh');
        });
        
        self.update();
    },   
}
</script>

<style>
  .inbox-badge {
      position: relative;
      top: -9px;
      right: 7px;
      display: inline-block;
      font-size: .6em;
      text-align: center;
      vertical-align: middle;      
  }
</style>


